import {
  DeleteAccountError,
  DeleteAccountErrorKind,
  FirebaseAuthErrorCode,
} from '@griply/types';
import { deleteUser } from 'firebase/auth';
import { getErrorReporter } from 'shared/services/error-tracking';

import { deletePushToken } from './delete-push-token';
import { getAuthentication, getPushNotificationToken } from './helpers';

export const deleteAccount = async () => {
  const auth = await getAuthentication();

  if (!auth.currentUser) {
    throw new DeleteAccountError(DeleteAccountErrorKind.NoUser);
  }

  try {
    const token = getPushNotificationToken(auth.currentUser.uid);
    await deletePushToken(token);
  } catch (error: unknown) {
    getErrorReporter().captureException(error, {
      tags: { source: 'firebase-delete-push-token' },
    });
  }

  try {
    await deleteUser(auth.currentUser);
  } catch (error: unknown) {
    const code = (error as { code?: string }).code ?? '';
    if (code === FirebaseAuthErrorCode.RequiresRecentLogin) {
      throw new DeleteAccountError(DeleteAccountErrorKind.RequiresRecentLogin);
    }

    getErrorReporter().captureException(error, {
      tags: { source: 'firebase-delete-account' },
    });
    throw new DeleteAccountError(DeleteAccountErrorKind.Unknown, {
      cause: error,
    });
  }
};
